var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"disabled":!_vm.clientReady},on:{"click":_vm.authorize}},'v-btn',_vm.$attrs,false),[_vm._v(" Authorize with Google ")])}
var staticRenderFns = []

export { render, staticRenderFns }